import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import Button from '../../../../common/base/Button';
import MultiTokenInput from '../../../../common/Form/Fields/MultiTokenInput';
import { useOutpostConfigUpdate } from '../../OutpostContext';
import { OutpostGetStartedStepProps } from '../GetStartedView';
const serializeTopics = (topics: string[]): string => topics.join(',');
const SetTopics: React.FC<OutpostGetStartedStepProps> = t0 => {
  const $ = _c(12);
  const {
    context: t1,
    nextStep,
    is_current_step
  } = t0;
  const {
    topics
  } = t1;
  const {
    config,
    updateConfig
  } = useOutpostConfigUpdate();
  let t2;
  if ($[0] !== topics) {
    t2 = {
      topics
    };
    $[0] = topics;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== nextStep || $[3] !== updateConfig) {
    t3 = async values => {
      const serialized = serializeTopics(values.topics || []);
      if (!values.topics || values.topics.length === 0) {
        const result = await updateConfig({
          TOPICS: serialized
        }, {
          success: "Topics updated",
          failure: "Failed to update topics"
        });
        if (result) {
          nextStep();
        }
        return;
      }
      const result_0 = await updateConfig({
        TOPICS: serialized
      }, {
        success: "Topics saved",
        failure: "Failed to save topics"
      });
      if (result_0) {
        nextStep();
      }
    };
    $[2] = nextStep;
    $[3] = updateConfig;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== config || $[6] !== is_current_step) {
    t4 = form_props => <Form><MultiTokenInput name="topics" placeholder="Type or paste topics..." help="Enter topic names (e.g., order.created, user.signup). Add in bulk by pasting a list." /><Button m={{
        t: 2
      }} outline={true} submit={true} disabled={form_props.isSubmitting || config?.TOPICS && config.TOPICS === serializeTopics(form_props.values.topics || []) || false} icon={form_props.isSubmitting ? "loading" : undefined}>{form_props.isSubmitting ? "Saving" : is_current_step ? "Next" : "Update"}</Button></Form>;
    $[5] = config;
    $[6] = is_current_step;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <Formik initialValues={t2} enableReinitialize={true} onSubmit={t3}>{t4}</Formik>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default SetTopics;